import Settings from 'settings';
var getAuth = function () {
    var authenticator = new Auth();
	return (() => import('@azure/msal-browser').then((Msal) => {

        const msalConfig = {
            auth: {
                clientId: authenticator.settings.ClientId,
                authority: authenticator.settings.Authority,
                knownAuthorities: [authenticator.settings.Authority],
                redirectUri: location.origin
            },
            cache: {
                cacheLocation: "sessionStorage"
            },
            system: {
                loggerOptions: {
                    loggerCallback(loglevel, message, containsPii) {
                        console.log(message);
                    },
                    piiLoggingEnabled: false,
					logLevel: Msal.LogLevel.Verbose,
				}
            }
		};

        return new Promise((resolve, reject) => {
            Msal.PublicClientApplication.createPublicClientApplication(msalConfig)
				.then((msalInstance) => {
                    authenticator.client = msalInstance;
                    resolve(authenticator);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }))();
}

var Auth = function () {
		var self = this;
		self.settings = Settings.Auth;

			self.login = function (successCallback, failCallback) {
				self.acquireToken(successCallback, function () {
					self.client.loginPopup({ scopes: self.settings.B2CScopes }).then(function (authenticationResult) {
						if (typeof successCallback === 'function') {
							successCallback(authenticationResult.accessToken);
						}
					}, function (error) {
						if (typeof failCallback === 'function') {
							failCallback(error);
						}
					});
				});
			};
		
            self.acquireToken = function (successCallback, failCallback) {
                successCallback = typeof successCallback === 'function' ? successCallback : function () { };

                return self.client.acquireTokenPopup({ scopes: self.settings.B2CScopes })
                    .then(function(authenticationResult) {
                        successCallback(authenticationResult.accessToken);
                        return authenticationResult;
                    }).catch(function (popupError) {
                        if (typeof failCallback === 'function') {
                            failCallback(popupError);
                        }
                        throw popupError;
                    });
            };
		
			self.logout = function () {
				self.client.logout();
			};
}

export default getAuth;